import classNames from 'classnames'

import { useMouseHover, useNavigateBack } from '../../../hooks'
import { EntityProfileHeaderAvatar } from '../EntityProfileHeaderAvatar'
import { EntityProfileHeaderText } from '../EntityProfileHeaderText'
import { EntityProfileHeaderTitleActions } from '../EntityProfileHeaderTitleActions'
import { EntityProfileHeaderTitleBackButton } from '../EntityProfileHeaderTitleBackButton'

import * as styles from './EntityProfileHeaderTitle.module.css'

function EntityProfileHeaderTitle({
  Actions = EntityProfileHeaderTitleActions,
  BackButton = EntityProfileHeaderTitleBackButton,
  EntityAvatar = EntityProfileHeaderAvatar,
  Text = EntityProfileHeaderText,
  actionsProps,
  backButtonProps,
  className = styles.EntityProfileHeaderTitle,
  entityAvatarProps,
  isArchived,
  isHeaderOpen,
  isLoading,
  sectionBackUrl,
  text,
  textContainerClassName = styles.textContainer,
  textPlaceholder,
  textProps,
}) {
  const [ref, isHovered] = useMouseHover()
  const handleClickBackBtn = useNavigateBack(sectionBackUrl)

  const titleClassName = classNames(className, { [styles.open]: isHeaderOpen })

  return (
    <div className={titleClassName} ref={ref}>
      {BackButton ? (
        <BackButton
          {...backButtonProps}
          isLoading={isLoading}
          onClick={handleClickBackBtn}
        />
      ) : null}
      <div className={textContainerClassName}>
        {EntityAvatar ? (
          <EntityAvatar {...entityAvatarProps} isLoading={isLoading} />
        ) : null}
        <Text
          {...textProps}
          isArchived={isArchived}
          isLoading={isLoading}
          isOpen={isHeaderOpen}
          text={text}
          textPlaceholder={textPlaceholder}
        />
        {Actions ? (
          <Actions
            {...actionsProps}
            isArchived={isArchived}
            isHeaderOpen={isHeaderOpen}
            isHovered={isHovered}
            isLoading={isLoading}
          />
        ) : null}
      </div>
    </div>
  )
}

export default EntityProfileHeaderTitle
